// eslint-disable-next-line no-undef
const axios = require('axios');

// Create an axios instance
const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  if (config.data && typeof config.data === 'object') {
    config.data = removeEmptyStringsAndNull(config.data);
  }
  return config;
});

// Function to recursively remove empty values from an object
const removeEmptyStringsAndNull = (obj) => {
  if (obj === null || obj === undefined) return null;
  if (typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) {
    const cleanedArray = obj
      .map(removeEmptyStringsAndNull)
      .filter((value) => value !== null && value !== undefined);

    return cleanedArray.length ? cleanedArray : null;
  }

  const cleanedObj = Object.fromEntries(
    Object.entries(obj)
      .map(([key, value]) => [key, removeEmptyStringsAndNull(value)])
      .filter(
        ([_, cleanedValue]) =>
          cleanedValue !== null &&
          cleanedValue !== undefined &&
          cleanedValue !== ''
      )
  );

  return Object.keys(cleanedObj).length ? cleanedObj : null;
};

// fetch charging stations
const fetchStations = (accessToken, cpoId) => {
  const STATION_ENDPOINT = `${window._env_.REACT_APP_API_ROOT_URL}/cpos/${cpoId}/charging-stations`;
  return axiosInstance.get(STATION_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// post contact us form data
const postFeedback = (accessToken, payload) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/mail/send`;
  return axiosInstance.post(API_URL, payload, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

//get a particular billing record starting from its billingNr
const fetchBilling = (billingNr, token) => {
  const BILL_ENDPOINT = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/get-bill/${billingNr}`;
  return axiosInstance.get(BILL_ENDPOINT, {
    params: {
      billingNr: billingNr,
    },
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

//for the betreiber anlegen form
const createNewOperator = (accessToken, payload) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpos/create-operator`;
  return axiosInstance.post(API_URL, payload, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const createNewLocation = (accessToken, payload) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/locations/location`;
  return axiosInstance.post(API_URL, payload, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchOperatorContracts = (accessToken, params) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/contracts/operator?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchGraph = (accessToken, params) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/kpi/get-graph?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchdashboardusersbyid = (accessToken, customerId, params) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpos/get-dashboard-user/${customerId}?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchParkingInfo = (accessToken) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/locations/parking-info`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchLocationById = (accessToken, locationId) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/locations/${locationId}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const getDashboardUsers = (accessToken, params) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpos/get-all-customer?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
const fethcChargingHistory = (accessToken, params) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/get-charging-history?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchLocations = (accessToken, urlParams) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/locations/get-by-cpo`;
  return axiosInstance.get(API_URL, {
    params: urlParams,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchLocationsForDropDown = (accessToken) => {
  // create a function to fetch locations and use it on cockpit
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/locations/get-by-cpo-for-dropdown`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchWallboxTypes = (accessToken) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/locations/wallboxTypes`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchOperators = (accessToken, params) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpos?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchCharginStations = (accessToken, urlParams) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/connectors/get-by-cpo`;
  return axiosInstance.get(API_URL, {
    params: urlParams,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchUsersByLocationId = (accessToken, locationId, urlParams) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/location/${locationId}/contracts`;
  return axiosInstance.get(API_URL, {
    params: urlParams,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchBills = (accessToken, urlParams) => {
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/get-bills/operator`;
  return axiosInstance.get(API_URL, {
    params: urlParams,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
const fetchConfigurationsDropDownForCpo = (accessToken, urlParams) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpo-configuration/values`;
  return axiosInstance.get(API_URL, {
    params: urlParams,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchOperatorDetails = (accessToken, customerId) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpos/${customerId}/operator-details`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchContractByRecordId = (accessToken, recordId) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/contract/id/${recordId}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const fetchDashboardUsersByCustomerId = (accessToken, customerId) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/cpos/get-customer/${customerId}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const changeAvailability = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/ocpp-client/change-availability`;
  return axiosInstance.put(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const changeParkingLot = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/connectors/update-connector-status`;
  return axiosInstance.put(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const createCP = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/connectors/create-cp`;
  return axiosInstance.post(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const refreshTokenRequest = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_USER_SERVICE}/refresh-token`;
  return axiosInstance.post(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// Change configuration endpoint for a charging station
const changeConfiguration = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/ocpp-client/change-configuration`;
  return axiosInstance.post(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// Change configuration endpoint for a charging station
const cleanChargingRequests = (accessToken, minutesThreshold) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/charging-requests/clean?minutesThreshold=${minutesThreshold}`;
  return axiosInstance.put(API_URL, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// Change configuration endpoint for a charging station
const deleteUserContract = (accessToken, contractId) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/delete-contract/${contractId}`;
  return axiosInstance.delete(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// get all RFIDs
const getAllRFIDs = (accessToken, params) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/auth/get-rfid-tags?${params.toString()}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// create  RFID
const createRFID = (accessToken, reqBody) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/auth/save-rfid-tags`;
  return axiosInstance.post(API_URL, reqBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// Create connectors using csv at charging station page
const createConnectorViaCSV = async (accessToken, requestBody, separator) => {
  const API_URL =
    `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/connectors/upload?csvSeparator=` +
    separator;
  return await fetch(API_URL, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: requestBody,
  }).then((r) => r.json());
};

const changeBillingStatus = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/billing-status-update`;
  return axiosInstance.put(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const retryStripeSepaPayment = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/stripe-sepa-payments/generate-for-bill`;
  return axiosInstance.post(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const sendBillsPdfEmail = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/send-bill-email`;
  return axiosInstance.post(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const downloadBills = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/download-bill`;
  return axiosInstance.post(API_URL, requestBody, {
    responseType: 'arraybuffer',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const regenerateIncorrectBills = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/bookings/regenerate-bills`;
  return axiosInstance.post(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const terminateContract = (accessToken, requestBody) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/terminate-contract`;
  return axiosInstance.put(API_URL, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

//export Connector Passwords
const exportConnectorPasswords = (connectors, token) => {
  const BILL_ENDPOINT = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/connectors/export-csv`;
  return axiosInstance.get(BILL_ENDPOINT, {
    params: {
      connectors: connectors,
    },
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

//get Charging Station Info and KPI
const chargingStationInfoAndKPI = (token, connectorId) => {
  const API_URL = `${window._env_.REACT_APP_BACKEND_FOR_FRONTEND_API}/connectors/${connectorId}`;
  return axiosInstance.get(API_URL, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

const redoStripeSepa = (accessToken, contractKey) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/reconfigure-stripe-sepa/${contractKey}`;
  return axiosInstance.post(API_URL, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const endCustomerIdValidationOnCreate = (accessToken, endCustomerId) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/end-customer-id/${endCustomerId}/validate/on-create`;
  return axiosInstance.post(API_URL, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
const endCustomerIdValidationOnUpdate = (
  accessToken,
  endCustomerId,
  contractDbId
) => {
  const API_URL = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/end-customer-id/${endCustomerId}/validate/on-update/${contractDbId}`;
  return axiosInstance.post(API_URL, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const exportChargingHistory = (accessToken, params) => {
  const BOOKING_ENDPOINT = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/download-center/charging-history/export?${params.toString()}`;
  return axiosInstance.get(BOOKING_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
const exportStandardBills = (accessToken, params) => {
  const BOOKING_ENDPOINT = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/download-center/standard-bills/export?${params.toString()}`;
  return axiosInstance.get(BOOKING_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
const exportErpDataBills = (accessToken, params) => {
  const BOOKING_ENDPOINT = `${window._env_.REACT_APP_BOOKING_SERVICE_API}/download-center/erp-data/export?${params.toString()}`;
  return axiosInstance.get(BOOKING_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// eslint-disable-next-line
export default {
  fetchStations: fetchStations,
  postFeedback: postFeedback,
  fetchBilling: fetchBilling,
  createNewOperator: createNewOperator,
  createNewLocation: createNewLocation,
  fetchLocations: fetchLocations,
  fetchGraph: fetchGraph,
  fetchParkingInfo: fetchParkingInfo,
  fetchdashboardusersbyid: fetchdashboardusersbyid,
  fetchLocationById: fetchLocationById,
  getDashboardUsers: getDashboardUsers,
  fethcChargingHistory: fethcChargingHistory,
  fetchWallboxTypes: fetchWallboxTypes,
  fetchOperators: fetchOperators,
  fetchUsersByLocationId: fetchUsersByLocationId,
  fetchCharginStations: fetchCharginStations,
  fetchOperatorContracts: fetchOperatorContracts,
  fetchDashboardUsersByCustomerId: fetchDashboardUsersByCustomerId,
  changeAvailability: changeAvailability,
  changeParkingLot: changeParkingLot,
  createCP: createCP,
  refreshTokenRequest: refreshTokenRequest,
  changeBillingStatus: changeBillingStatus,
  terminateContract: terminateContract,
  fetchOperatorDetails: fetchOperatorDetails,
  chargingStationInfoAndKPI: chargingStationInfoAndKPI,
  retryStripeSepaPayment: retryStripeSepaPayment,
  fetchBills: fetchBills,
  sendBillsPdfEmail: sendBillsPdfEmail,
  downloadBills: downloadBills,
  regenerateIncorrectBills: regenerateIncorrectBills,
  redoStripeSepa: redoStripeSepa,
  fetchLocationsForDropDown: fetchLocationsForDropDown,
  changeConfiguration: changeConfiguration,
  createConnectorViaCSV: createConnectorViaCSV,
  cleanChargingRequests: cleanChargingRequests,
  deleteUserContract: deleteUserContract,
  getAllRFIDs: getAllRFIDs,
  createRFID: createRFID,
  exportConnectorPasswords: exportConnectorPasswords,
  fetchConfigurationsDropDownForCpo: fetchConfigurationsDropDownForCpo,
  endCustomerIdValidationOnCreate: endCustomerIdValidationOnCreate,
  endCustomerIdValidationOnUpdate: endCustomerIdValidationOnUpdate,
  fetchContractByRecordId: fetchContractByRecordId,
  exportChargingHistory: exportChargingHistory,
  exportStandardBills: exportStandardBills,
  exportErpDataBills: exportErpDataBills,
};
